import { render, staticRenderFns } from "./TabbedInventory.vue?vue&type=template&id=713c7899&scoped=true"
import script from "./TabbedInventory.vue?vue&type=script&lang=js"
export * from "./TabbedInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c7899",
  null
  
)

export default component.exports